import { useEffect, useCallback, useMemo, useState, useRef, useContext } from "react";
import { createRoot } from 'react-dom/client';
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "./customStyles.css";
import { ModuleRegistry } from '@ag-grid-community/core';
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./CustomersGrid.module.scss";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import useEffectIgnoreFirst from "../../hooks/useEffectIgnoreFirst";
import ButtonLink from "../UI/ButtonLink";
import Button from "../UI/Button";
import CalendyModal from "./CalendyModal";


ModuleRegistry.registerModules([InfiniteRowModelModule]);

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("EU_Invoices_REI");


const ContactUsForPayment = ({...props}) => {
    const table =useRef();
    const [requestParams, setRequestParams] = useState();
    const {sessionInfo, mainOrgId} = useContext(OrgIdContext)
    const [search, setSearch] = useState();
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    return (
        <div style={{ height: '100%', width: '100%',display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* <div style={{marginTop:"10rem"}}>Please schedule a meeting for a price <Button className="ps-2 pe-2" onClick={() => setShowModal(true)}>here</Button></div>
            <CalendyModal show={showModal} onHide={() => setShowModal(false)}/> */}
            <div className="text-center">Please schedule a meeting for a price</div>
            {/* "45min" event was renamed/removed on Calendly's side (404) — "30min-intro"
                is the current slug, confirmed live on dddinvoices.com's own "Book a
                meeting" button. */}
            <iframe src="https://calendly.com/ddd-invoices/30min-intro" style={{width:"100%", height:"100%"}}></iframe>
        </div>
        );
};

export default ContactUsForPayment;
